import { getSiteInfo, getSiteConfigs, setGlobalSiteConfigs, getLazySizesConfig } from '../SiteConfigs.js';
import LoadMore from './LoadMore.js';
window.load_more = LoadMore;

function init_articles_js(){

    //NON HTML5 SUPPORT/BROWSERS MOCK HISTORY API USAGE - NEEDS HASH ON UNSUPPORTED VERSIONS
    //IF <= IE 9 CHECK FOR HASH IN URL - IF EXISTS RELOAD PAGE WITH NEW PERMALINK LOCATION - FOR NON HTML5 BROWSERS
    function getUrlHash(){
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('#') + 1).split('&');

        for(var i = 0; i < hashes.length; i++){
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    var redir = getUrlHash()['redir'];

    if(redir!="" && redir!=undefined){
        location.replace(redir);
    }

    //count how many articles there are already in the page
    $(document).ready(function(){

        setGlobalSiteConfigs();
        
        load_more.get_innitial_items_count();
        progressBar();
        donationsPopUp();
        fullScreenModal();
        // triggerTimOutstreamArticleVideo();

        if( SITE_INFO['name'] === 'politics' ){
            // initInsightsLibrary();
        }

    });

    //on click we call the append_items function
    $(document).on('click', '#load_more', function(){ 
        
        //reset error count before loading more
        load_more.error_count = 0;

        //load more into DOM
        load_more.append_items();
    });

    $( document ).ready(function(){	

        //Sharepoints Handler - Will open pop-up to tweet Title - Sharepoint Text URL For Given Sites
        if( $(".sharepoint-wrapper").length > 0 && SITE_INFO['name'] == "defense" ){
    
            $(".sharepoint-icon").click(function() {
                var ref_url = window.location.href;
                var ref_title = $(document).find("title").text();
                var share_text = $(this).next(".sharepoint-text").text();
                var twt_share_text = ref_title + ' - ' + share_text;
                var share_url = 'http://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ encodeURIComponent(twt_share_text) +'&amp;related='+twt_related;			
                share_url = share_url.replace("039", "");
                share_url = share_url.replace("'", "");
                
                rctools_openShareWindow('twitterwindow',share_url);
            });
        }
    
    }); //end DOC READY

}

function initInsightsLibrary(){

    if(typeof _ain !== 'undefined') { // Make sure config exists on page

        // If "evaf" cookie exists, that means the user is a paid ad-free subscriber
        // Else, if "rcmg_guid" cookie exists, they are registered user
        if(readCookie('evaf')) {
            _ain['reader_type'] = "subscribed";
        } else if(readCookie('rcmg_guid')) {
            _ain['reader_type'] = "registered";
        }

        (function (d, s) {
            var sf = d.createElement(s);
            sf.type = 'text/javascript';
            sf.async = true;
            sf.src = (('https:' == d.location.protocol)
            ? 'https://d7d3cf2e81d293050033-3dfc0615b0fd7b49143049256703bfce.ssl.cf1.rackcdn.com'
            : 'http://t.contentinsights.com') + '/stf.js';
            var t = d.getElementsByTagName(s)[0];
            t.parentNode.insertBefore(sf, t);
        })(document, 'script');
    }

}

function fullScreenModal(){

    if($('img.rc_fullscreen_click').length) {

        $('img.rc_fullscreen_click').click(function() {

        var close_modal = function() {
            $('.rc_fullscreen_modal').remove();
        };

        close_modal();

        var img = $(this).attr('src').replace(/_[1-9]_/, '');

        var html = "";

        html += "<div class='rc_fullscreen_modal'>";
            html += "<div class='image' style='background-image: url("+img+")'></div>";
            html += "<div class='close'>X</div>";
        html += "</div>";

        $('body').append(html);

        $('.rc_fullscreen_modal').click(close_modal);
        $('.rc_fullscreen_modal .image .close').click(close_modal);

        });
    }
}

function donationsPopUp(){

    /*
    * Investigations only on articles that are featured on advance settings
    * */
    if($('body').hasClass('featured-article') && siteName == 'investigations'){

        var options = {
            root: null,
            threshold: 1.0
        };

        var observer = new IntersectionObserver(investigations_donation_campaign, options);

        function investigations_donation_campaign( entries, observer) {

            entries.forEach(entry => {
                if(entry.isIntersecting){
                    //logic to execute when its an article to display an ad.
                    display_donations_overlay();
                    console.log('executed and stop observing');
                    observer.unobserve(document.querySelector('.donations_footer'));
                }
            });
        };

        var target = document.querySelector('.donations_footer');
        observer.observe(target);


        function display_donations_overlay(){
            if(typeof Tempshow !== 'undefined' ) {

                var tempshow = new Tempshow;

                tempshow.create({
                    msg: 'Want to see more investigations like this one? Please make a tax-deductible contribution to RealClearInvestigations.<br><a class="donate_popup_btn" href="https://donations.realclearinvestigations.com/donations.html">Click Here to Support Our Work</a>',
                    type: 'donation_call',
                    seconds: 200,
                    vertical: 'center',
                    horizontal: 'center',
                    width: '500px'
                });

                var data = {
                    'ge_action' : 'overlay shown',
                    'ge_category' : 'notices',
                    'ge_label' : 'Donation Scroll Bottom Popup',
                    'ge_noninteraction' : true
                };

                send_ga_event(data);

            }
        }
    }

}



//ARTICLE TEMPLATE SCRIPTING
var ua = window.navigator.userAgent; //current User Agent
var msie = ua.indexOf("MSIE "); //IE User Agent Match(returns boolean)) 

function progressBar(){

  var bars = $('.progress-bar').length;

  	if( $('.progress-bar .progress-bg').length == 0 ){
		$('.progress-bar').html('<div class="progress-bg"></div>');
	}

  $(window).scroll(function (){

	 var top = $(this).scrollTop();

	// Calculate each article section
	$("article").each(function(i){

		var this_top = $(this).offset().top;
		var height = $(this).height();
		var this_bottom = this_top + height;
		var percent = 0;

		// Scrolled within current section - sets percentage based on position
		if (top >= this_top && top <= this_bottom) { //if inside the "active" article
			percent = ((top - this_top) / height) * 100;
		}
		else if (top > this_bottom) {
			percent = 100;
		}

		//only active article will have less than 100 - if not active hide
		if( percent == 100 ){
			$(".progress-bar:eq("+i+")").hide();
		}else{
			$(".progress-bar:eq("+i+")").show();
		}

		//set width to progress bar of current article section(i)
		$(".progress-bar:eq("+i+")").css("width", percent + "%");
		$(".progress-bar .progress-bg").css("width", (100 - parseFloat(percent)) + "%");


	}); //end .each article

  }); //end window .scroll function

}

var viewport = viewportSize.getWidth();
var prev_viewport = viewport;

var current_total = 0; 
var pix = 0; //items counter
var pitems_per_slide = 1; //how many items to start
var pstart = 0; //starting index
var pend = pitems_per_slide; //end index
//var current_time = new Date();
//var pyear = current_time.getFullYear();	//M.B. UPDATED 5/24/18 -- NEED ACCURATE TIME HERE OTHERWISE WILL NEVER GET CORRECT CONTENT ON LOAD MORE
var pyear = 2016;
var pdata = '';
var d = '';
var rix = 0; //remaining items count(12 item panels - last panel != 12)
var buffer_items = [];
var video_items = [];
var filtered_items = [];
var bottom_item_ids;
var pop_item_ids;
var day;
var featured_entry_id;
var startDay,startMonth,startYear,pday,pmonth,cyear;
var MAX_FAIL_DAYS = 30;
var fail_days_in_a_row = 0;
var itemDate = 0;
var first_run = 0;
var second_run = 0;
var removed_count = 0;
var num_appended_count = 0;
var first_insert_count = 0;


function pappendFeedData(display_items){	
	var tracker = 1;
	
	display_items.sort(function(a,b){ 
	  // Turn your strings into dates, and then subtract them
	  // to get a value that is either negative, positive, or zero.
	  return new Date(a.date) - new Date(b.date);
	});
	
	$.each(display_items, function(i, item) {

		//console.log(item);
		
		var months = Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
		var days =   Array("Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday");

		var itemID = item.id;
		var itemImg = item.image;
		var itemLink = item.link;
		var itemExc = item.excerpt;
		var itemByline = item.byline;
		var author = item.author;
		var postDate = item.postDate;
		var itemTitle = item.title.replace(/&acute;/g, "&#039;");

		var date = new Date(item.date);
		
		var dhtml = "";

		/*if(itemDate.length == 0){
			itemDate = item.date;
		}*/
		//console.log("Run: "+tracker+ " itemDate var: "+ itemDate+ " JSON date: "+item.date);

		/*if(itemDate != item.date){
			dhtml += '<div style="color:#000; font-size:1.5em; font-weight:bold; margin:0px; padding:10px 0px 4px 0px;">'+days[date.getDay()]+ ', ' + months[date.getMonth()] + ' ' + date.getDate()+'</div>';
			itemDate = item.date;
		}*/
		
		dhtml += '<div class="post item" data-id="'+itemID+'" data-year="" data-month="" data-day="">';
			dhtml += '<div class="section-social" data-feed-description="'+itemTitle+'" data-feed-caption="'+itemByline+'">';
				dhtml += '<div class="socialBar" data-style="short" data-dialog="share" data-src-title="'+itemTitle+'" data-src-url="'+itemLink+'"><div class="left toolset"></div></div>';
				dhtml += '<div class="socialBar-clicks"></div>';
				dhtml += '<div class="socialBar-divide"></div>';
				dhtml += '<div class="socialBar-shares"></div>';
			dhtml += '</div>';
	
			dhtml += '<h2 id="article-title"><a href="'+itemLink+'">'+itemTitle+'</a></h2>';
			dhtml += '<p class="author">';
				dhtml += '<strong>'+author+'</strong> - '+ postDate;
			dhtml += '</p>';
			
			dhtml += '<div id="article_body" class="article_body">';
			
				/*dhtml += '<div class="image" style="'.$ae_pic_container_styles.'">';
					dhtml += '<img src="'+itemImg+'" width="100%" />';      
				dhtml += '</div>';*/
				
				//excerpt -- 4 paras
				dhtml += itemExc;
				
				dhtml += '<div class="big_more"><a href="'+itemLink+'">Read Full Story <span>»<span></a></div>';
			
			dhtml += '</div><!-- article_body -->';
		

		
			/*dhtml += "<a href='"+itemLink+"'>" +
				'<div class="vt-bg-item"><img src="'+itemImg+'" /></div>' +
				'<span class="vital-title"><p>'+itemTitle+'</p></span>' +
				'<img class="vs-logo" src="/asset/img/vs-logo.png">' +
			"</a>";*/
		dhtml += '</div> ';

				

		//console.log(dhtml);
		
		$('.more-posts').append(dhtml);	
		//$(".alpha .last").after(dhtml);	
		$('.ajaxRight').hide();
		tracker++; //increase item counter					
	});					
}
//end load more

//helper function to ensure day of month remains 2 digit
function pad(n) {
    return (n < 10) ? ("0" + parseInt(n)) : n;
}

/**
 * Lazy loads the Tim Outstream video into an article. 
 * Loads video when the user scrolls by the location of containerTarget
 */
function triggerTimOutstreamArticleVideo()
{
    var containerTarget = '.article-body-text > p:nth-child(16)';

    if($(containerTarget).length == 0){
        return;
    }

    $('<div id="tim_outstream_video" class="tim-outstream-lazyjs"></div>').insertAfter( containerTarget );

    var intervalTimOutstream = setInterval(function(){

        var target = '.tim-outstream-lazyjs';

        if($(target).length > 0 && isVisibleOnScreen(document.getElementById("tim_outstream_video")) ){

            var script      = document.createElement("script");
            script.type     = "text/javascript";
            script.src      = '//stg.truvidplayer.com/index.php?sub_user_id=648&widget_id=2949&playlist_id=2125&m=a&cb=' + (Math.random() * 10000000000000000);
            $(script).insertAfter(target);

            clearInterval(intervalTimOutstream);

        }

    }, 250);
}

export default init_articles_js;